import { CarDto } from '@/api/generated';
import { CarDetailsTab } from '@/views/cars/details/model/CarDetailsTab.model.ts';
import { SupplierDetailsTab } from '@/views/suppliers/details/model/SupplierDetailsTab.model.ts';

export type CarsDetailsTranslation = {
  header: {
    button: {
      edit: string;
    };
  };
  main: {
    fields: Record<keyof Omit<CarDto, 'carId' | 'createdAt'>, string>;
  };
  tabs: Record<CarDetailsTab, string>;
};

export const carsDetailsTranslation: CarsDetailsTranslation = {
  header: {
    button: {
      edit: 'Edytuj',
    },
  },
  main: {
    fields: {
      licensePlate: 'Nr rejestracyjny',
      mileage: 'Przebieg',
      model: 'Model',
      note: 'Notatka',
      responsibleUser: 'Opiekun auta',
      status: 'Status',
      type: 'Typ',
      vin: 'Nr VIN',
      year: 'Rocznik',
    },
  },
  tabs: {
    [SupplierDetailsTab.FILES]: 'Pliki',
    [SupplierDetailsTab.TASKS]: 'Zadania',
  },
};
